import * as React from "react";
const IconTargetRevenue = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M61 29.8h-5.2C54.7 18.4 45.6 9.3 34.3 8.2V3c0-1.2-1-2.3-2.3-2.3-1.2 0-2.3 1-2.3 2.3v5.2C18.4 9.3 9.3 18.4 8.2 29.8H3c-1.2 0-2.3 1-2.3 2.3 0 1.2 1 2.3 2.3 2.3h5.2C9.3 45.8 18.4 54.9 29.8 56v5c0 1.2 1 2.3 2.3 2.3 1.2 0 2.3-1 2.3-2.3v-5.2C45.8 54.7 54.9 45.6 56 34.2h5c1.2 0 2.3-1 2.3-2.3 0-1.1-1.1-2.1-2.3-2.1M34.3 51.3v-.8c0-1.2-1-2.3-2.3-2.3-1.2 0-2.3 1-2.3 2.3v.8c-8.9-1-16-8.1-17-17h.8c1.2 0 2.3-1 2.3-2.3 0-1.2-1-2.3-2.3-2.3h-.8c1-8.9 8.1-16 17-17v.8c0 1.2 1 2.3 2.3 2.3 1.2 0 2.3-1 2.3-2.3v-.8c8.9 1 16 8.1 17 17h-.8c-1.2 0-2.3 1-2.3 2.3 0 1.2 1 2.3 2.3 2.3h.8c-1.1 8.9-8.1 15.9-17 17" />
    <path d="M34.5 29.8h-5c-.8 0-1.5-.6-1.5-1.3s.7-1.3 1.5-1.3h7.4c1.2 0 2.3-1 2.3-2.3s-1-2.3-2.3-2.3h-2c0-1.2-1-2.2-2.2-2.2s-2.2 1-2.2 2.2h-.9c-3.3 0-6 2.6-6 5.8s2.7 5.8 6 5.8h5c.8 0 1.5.6 1.5 1.3s-.7 1.3-1.5 1.3h-8.4c-1.2 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3h4.4c0 1.2 1 2.2 2.2 2.2s2.2-1 2.2-2.2c3.1-.2 5.6-2.7 5.6-5.8-.1-3.2-2.8-5.8-6.1-5.8" />
  </svg>
);
export default IconTargetRevenue;
